import React from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';
import Checkbox from '../../../../view/view-checkbox';
import { isDragula } from '../../../../util/cubeUtil';
import ModeExcel from '../../../../stores/card/ModeExcel';
import CardStore from '../../../../stores/card';

export interface DetailCheckAllProps{
    excel: ModeExcel;
    form: any;
    card: CardStore;
    detail?: string;
}

@observer
export default class DetailCheckAll extends React.Component<DetailCheckAllProps, any> {
    render() {
        const { card, detail, form, excel } = this.props;
        let viewAttr = card.params.type == '1' || card.params.type == '2' ? 2 : 1;
        const detailField = form.$(detail);
        let _values: string[];
        const { isCopy = false, isDelete = false } = excel.detailProps;
        if (!isDelete && detail) {    //如果设置了不允许删除已有明细
            _values = detailField.values().filter(val => !val.dtl_id);
            _values = _.values(_.mapValues(_values, 'checkbox'));
        } else {
            _values = _.values(_.mapValues(detailField.values(), 'checkbox'));
        }
        if(card.params.type == '0' && isCopy ||isDelete){ //显示布局下。允许快速编辑，开启删除‘复制功能允许勾选
            viewAttr = 2;
        }
        const __values = _values.filter(d => d == '1');
        // const checkAll = __values.length == _values.length && __values.length > 0;
        const checkSome = __values.length > 0 && __values.length < _values.length;
        const id = "_" + detail + "_all";
        let style={};
        let isDrag=isDragula(card,detail);
        if(isDrag){
            style={marginLeft:17};
        }
        return (
            <Checkbox style={style}
                {...{ id: id, name: id }}
                onChange={this.checkAllChange}
                indeterminate={checkSome}
                // checked={checkAll}
                disabled={viewAttr == 1}
            />
        )
    }

    checkAllChange = (e) => {
        const { checked } = e.target;
        const { detail, form, excel } = this.props;
        let canNotDeleteHis: boolean = false;
        if (!excel.detailProps.isDelete && detail) {
            canNotDeleteHis = true;
        }

        form.checkAll(detail, checked, canNotDeleteHis);
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/checkbox-element/DetailCheckAll.tsx